import PortfolioPageLayout from "../PortfolioPageLayout";
import northTableData from "../NorthTable/northTableData";

function NorthTable() {
  return <PortfolioPageLayout {...northTableData} />;
}

export default NorthTable;